import { IAccQuyDoiTyGia } from "../../model/respone/category/IAccQuyDoiTyGia";
import { apiClient } from "../apiClient";
export const QUYDOITYGIA_ENDPOINT = "quy-doi-ty-gia";
export const quyDoiTyGiaApi = {
  SelectAll: () => apiClient.get(`${QUYDOITYGIA_ENDPOINT}`),
  Insert: (payload: IAccQuyDoiTyGia) =>
    apiClient.post(`${QUYDOITYGIA_ENDPOINT}`, payload),
  Update: (payload: IAccQuyDoiTyGia) =>
    apiClient.put(`${QUYDOITYGIA_ENDPOINT}`, payload),
  Delete: (id: number) => apiClient.delete(`${QUYDOITYGIA_ENDPOINT}/${id}`),
};
